import { AppBar, Toolbar, Typography, Box, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { UserInfo } from "src/components/common/Header/UserInfo";
import { useAppSelector } from "src/redux/store";

const MainHeader = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // check for mobile
  const userInfo = useAppSelector((state) => state.root.user.data);

  return (
    <AppBar
      position="static"
      sx={{
        backgroundColor: "#0D9488", // deep green
        paddingY: 1,
      }}
    >
      <Toolbar
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
        }}
      >
        {/* Left Logo + Title */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1.5,
          }}
        >
          <Box
            component="img"
            src="/assets/images/GCP.png"
            alt="GCP Logo"
            sx={{
              width: isMobile ? 40 : 50,
              height: isMobile ? 40 : 50,
              borderRadius: "8px",
              padding: 0.5,
            }}
          />
          <Typography
            variant={isMobile ? "subtitle1" : "h6"}
            fontWeight="bold"
            color="white"
          >
            GREEN CREDIT PROGRAMME
          </Typography>
        </Box>

        {/* Right Logo + Title */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1.5,
            marginTop: isMobile ? 1 : 0,
          }}
        >
          <UserInfo
            customStyles={{
              name: {
                color: "#fff",
              },
              dropDown: {
                color: "#fff",
              },
            }}
          />
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default MainHeader;
